// Survey mutations
export const GET_SURVEYS_PENDING = "GET_SURVEYS_PENDING";
export const GET_SURVEYS_SUCCESS = "GET_SURVEYS_SUCCESS";
export const GET_SURVEYS_FAIL = "GET_SURVEYS_FAIL";

export const SURVEYS_ANSWERS_PENDING = "SURVEYS_ANSWERS_PENDING";
export const SURVEYS_ANSWERS_SUCCESS = "SURVEYS_ANSWERS_SUCCESS";
export const SURVEYS_ANSWERS_FAIL = "SURVEYS_ANSWERS_FAIL";

export const GET_SURVEYS_RESULT_PENDING = "GET_SURVEYS_RESULT_PENDING";
export const GET_SURVEYS_RESULT_SUCCESS = "GET_SURVEYS_RESULT_SUCCESS";
export const GET_SURVEYS_RESULT_FAIL = "GET_SURVEYS_RESULT_FAIL";

// Survey state mutations
export const SET_CURRENT_QUESTION_NUMBER = "SET_CURRENT_QUESTION_NUMBER";
export const SET_SHOW_SURVEY_VERIFICATION = "SET_SHOW_SURVEY_VERIFICATION";
export const SET_SHOW_SURVEY_RESULTS = "SET_SHOW_SURVEY_RESULTS";
export const SET_SHOW_SURVEY = "SET_SHOW_SURVEY";
